import { render, staticRenderFns } from "./ComboboxConsultant.vue?vue&type=template&id=0bc39af2&"
import script from "./ComboboxConsultant.vue?vue&type=script&lang=js&"
export * from "./ComboboxConsultant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports